
import { KayaContent } from "../../components/kaya";


export default function Kaya () {

  return (
    <>
      <KayaContent/>
    </>
  )

}